<template>
  <main>
    <nav :class="style.additional">
      <div
        :class="serviceSelected == '' ? style.active : ''"
        @click="serviceSelected = ''"
      >
        Все
      </div>
      <div
        :class="serviceSelected == service ? style.active : ''"
        @click="serviceSelected = service"
        v-for="service in getClinic?.servicesList"
        v-show="verifyServiceNav(service)"
        v-text="service"
      />
    </nav>
    <div
      @click="setConsultation()"
      :class="style.service + ' ' + style.consultation"
    >
      <div v-text="'Нужна помощь?'" />
      <div :class="style.choiceService" />
    </div>
    <div
      v-show="verifyService(name)"
      :key="name"
      v-for="(serviceArr, name) in serviceList as Record<string, any>"
    >
      <div :class="style.service + ' ' + style.heading" v-text="name" />
      <div
        @click="setService(service)"
        :class="style.service"
        v-for="service in serviceArr"
      >
        <div v-text="service.name" />
        <div style="display: flex; gap: 10px">
          <div v-text="service.cost" />
          <div :class="style.choiceService" />
        </div>
      </div>
    </div>
  </main>
</template>
<script lang="ts">
import style from "../StyleWidget.module.scss";
import {defineComponent} from "vue";
import type {doctor} from "@/page/onlineAppointment/doctors/DoctorsType";
import type {clinic} from "../../page/onlineAppointment/clinic/ClinicTypes";

interface serviceList {
  [key: string]: {
    name: string | number;
    cost: string;
  }[];
}

export default defineComponent({
  name: "ChoseService",
  data() {
    return {
      style,
      serviceSelected: ""
    };
  },
  methods: {
    setConsultation() {
      this.$widgetStore.updateConsultation(true);
    },
    verifyService(name: string) {
      if (this.serviceSelected == "") {
        return true;
      }
      return this.serviceSelected == name;
    },
    verifyServiceNav(service: string) {
      if (this.serviceList[service] != undefined) {
        return this.serviceList[service].length != 0;
      }
      return false;
    },
    checkName(list: serviceList[string], nameNew: string) {
      let bool = false;
      list.forEach((item) => {
        const nameOld = [item.name, item.cost].join(", ");
        if (nameOld == nameNew) {
          bool = true;
        }
      });
      return bool;
    },
    verifyAddressInDoctor(doctor: doctor) {
      let verify = false;
      for (const address in doctor.address) {
        if (Object.hasOwnProperty.call(doctor.address, address)) {
          const checked = doctor.address[address];
          if (checked) {
            verify = this.getAddressList.includes(address);
          }
        }
      }
      return verify;
    },
    getObjService(servise: {
      name: string;
      cost?: string | number;
      checked?: boolean;
    }) {
      function splitLastOccurrence(str: string, substring: string) {
        const lastIndex = str.lastIndexOf(substring);
        if (lastIndex == -1) {
          return [str, 0];
        }
        return [str.slice(0, lastIndex), str.slice(lastIndex + 1)];
      }

      let serviceSplit = splitLastOccurrence(servise.name, ", ");
      if (serviceSplit.length == 1) {
        serviceSplit = splitLastOccurrence(servise.name, " - ");
      }
      if (serviceSplit.length == 3) {
        serviceSplit[1] = serviceSplit[2];
        serviceSplit.pop();
      }

      let cost = serviceSplit[1] ? serviceSplit[1] : "0";
      if (cost == "0") {
        cost = servise.cost ? servise.cost : "0";
      }
      cost = String(cost);

      let prefix;
      if (cost.replaceAll(" ", "").slice(0, 2).toLowerCase() == "от") {
        prefix = "от";
      }

      cost = cost.replace(/\s/g, "");
      cost = String(cost.match(/\d+/g));
      if (cost.length > 4) {
        cost = cost.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      if (prefix != undefined) {
        if (cost == null || cost == "null") {
          cost = "0";
        }
        cost = prefix + " " + cost;
      }

      const symbol = this.getClinic?.currency?.symbol || "₽";
      cost += " " + symbol;
      cost = cost.replace(/ /g, "\u00a0");

      return {
        name: serviceSplit[0],
        cost
      };
    },
    getServiceList() {
      let serviceList: serviceList = {};

      this.getDoctors.forEach((doctor) => {
        if (doctor.service != null && this.verifyAddressInDoctor(doctor)) {
          Object.entries(doctor.service).forEach((serviceObj) => {
            let key = serviceObj[0];
            serviceList[key] = [];
            serviceObj[1].forEach((service) => {
              if (
                service.checked == true &&
                !this.checkName(
                  serviceList[key],
                  Object.values(this.getObjService(service)).join(", ")
                )
              ) {
                serviceList[key].push(this.getObjService(service));
              }
            });
          });
        }
      });

      type servicesList = typeof this.getClinic.servicesList;
      const servicesList: servicesList = this.getClinic.servicesList;
      if (servicesList) {
        let sortServiceList: serviceList = {};
        servicesList.forEach((element: servicesList[number]) => {
          if (
            serviceList[element] != undefined &&
            serviceList[element].length != 0
          ) {
            sortServiceList[element] = serviceList[element];
          }
        });
        return sortServiceList;
      }
      return serviceList;
    },
    setService(service: serviceList[string][number]) {
      const serviceArr = Object.values(service);
      this.chose.DoctorService = serviceArr.join(", ");
      this.$widgetStore.setSelectedStage(this.selectedStage + 1);
    }
  },
  computed: {
    getClinic(): Partial<clinic> {
      return this.$widgetStore.clinic;
    },
    getAddressList(): string[] {
      return this.getClinic?.addressList || [];
    },
    getDoctors(): doctor[] {
      return this.$widgetStore.getDoctors;
    },
    serviceList() {
      const doctorServices = this.chose.doctor.service;
      if (!doctorServices) {
        return this.getServiceList();
      }

      return Object.fromEntries(
        Object.entries(doctorServices).map(([name, services]) => [
          name,
          (
            services as Array<{
              name: string;
              cost?: string | number;
              checked: boolean;
            }>
          )
            .filter((service) => service.checked)
            .map((service) => this.getObjService(service))
        ])
      );
    },
    chose() {
      return this.$widgetStore.getChose;
    },
    selectedStage() {
      return this.$widgetStore.getSelectedStage;
    }
  }
});
</script>
